import { Outlet, useParams } from 'react-router-dom';

import { useApplicationQuery } from '@/hooks/api/queries/useApplicationQuery';
import { BuilderAppPageWrapper } from './BuilderAppPageWrapper';
import { BuilderSetup } from './BuilderSetup';
import { APP_LOAD_ERROR_MESSAGE } from './components/errors/ErrorFallback';
import { InactivityTimeout } from './components/InactivityTimeout';
import { MessagingContextProvider } from './context/MessagingContext';
import { PageContextProvider } from './context/PageContext';
import { SessionContextProvider } from './context/SessionContext';
import { ThemingContextProvider } from './context/ThemingContext';
import { FlagsmithSetup } from './FlagsmithSetup';
import { LiveAppSetup } from './LiveAppSetup';
import { PageModalWrapper } from './PageModalWrapper';
import { ThirdPartyIntegrationsSetup } from './ThirdPartyIntegrationsSetup';
import { isInternalBuilderIframe } from './utils/iframe';

export function App() {
  const { '*': pathnameFromParams } = useParams();

  const { data: application } = useApplicationQuery();

  if (!application || !application.account) {
    throw new Error(APP_LOAD_ERROR_MESSAGE);
  }

  if (isInternalBuilderIframe()) {
    return (
      <FlagsmithSetup accountId={application.account.id}>
        <ThemingContextProvider theming={application.theming}>
          <MessagingContextProvider>
            <BuilderSetup>
              <SessionContextProvider>
                <PageContextProvider
                  pathname={pathnameFromParams}
                  pages={application.pages}
                  homePage={application.homePage}
                >
                  <BuilderAppPageWrapper>
                    <Outlet />
                  </BuilderAppPageWrapper>
                </PageContextProvider>
              </SessionContextProvider>
            </BuilderSetup>
          </MessagingContextProvider>
        </ThemingContextProvider>
      </FlagsmithSetup>
    );
  }

  return (
    <FlagsmithSetup accountId={application.account.id}>
      <ThemingContextProvider theming={application.theming}>
        <LiveAppSetup>
          <SessionContextProvider>
            <ThirdPartyIntegrationsSetup>
              <PageContextProvider
                pathname={pathnameFromParams}
                pages={application.pages}
                homePage={application.homePage}
              >
                <PageModalWrapper pages={application.pages} homePage={application.homePage}>
                  <Outlet />
                  <InactivityTimeout />
                </PageModalWrapper>
              </PageContextProvider>
            </ThirdPartyIntegrationsSetup>
          </SessionContextProvider>
        </LiveAppSetup>
      </ThemingContextProvider>
    </FlagsmithSetup>
  );
}
